import { useI18n } from '@muse/i18n'

import { type AnalyticsPlacementTypes } from '@core/analytics'
import { DownloadIcon, IconButton, type TIconButtonVariant } from '@ds/components'
import type { TAudioSimple } from '@core/models'

import { useDownloadDialog } from '../hooks/useDownloadDialog'

export type TDownloadButtonContainerProps = {
    audio: TAudioSimple
    placement: AnalyticsPlacementTypes
    variant?: TIconButtonVariant
}

export const DownloadButtonContainer = ({
    audio,
    placement,
    variant,
}: TDownloadButtonContainerProps) => {
    const { t } = useI18n()
    const download = useDownloadDialog()

    const handleClick = () => {
        download.open(
            {
                id: audio.id,
                title: audio.title,
                authorUsername: audio.authorUsername,
                authorId: audio.authorId,
                avatarUrl: audio.avatarUrl,
            },
            placement,
        )
    }

    return (
        <IconButton
            variant={variant}
            Icon={DownloadIcon}
            aria-label={t('i18n.audioCardDownload')}
            srLabel={t('i18n.audioCardDownload')}
            data-test="audio-action-download"
            onClick={handleClick}
        />
    )
}
